import { CreateToastFnReturn } from "@chakra-ui/react";
import { store } from "tools/store";

export const getQuranPageBySurah = (surahNum: string) => {
  const all_pages: { [key: string]: any } = {
    "1": { page: 1, name: "Al-Fatihah" },
    "2": { page: 2, name: "Al-Baqarah" },
    "3": { page: 50, name: "Aal-E-Imran" },
    "4": { page: 77, name: "An-Nisa" },
    "5": { page: 106, name: "Al-Ma'idah" },
    "6": { page: 128, name: "Al-An'am" },
    "7": { page: 151, name: "Al-A'raf" },
    "8": { page: 177, name: "Al-Anfal" },
    "9": { page: 187, name: "At-Tawbah" },
    "10": { page: 208, name: "Yunus" },
    "11": { page: 221, name: "Hud" },
    "12": { page: 235, name: "Yusuf" },
    "13": { page: 249, name: "Ar-Ra'd" },
    "14": { page: 255, name: "Ibrahim" },
    "15": { page: 262, name: "Al-Hijr" },
    "16": { page: 267, name: "An-Nahl" },
    "17": { page: 282, name: "Al-Isra" },
    "18": { page: 293, name: "Al-Kahf" },
    "19": { page: 305, name: "Maryam" },
    "20": { page: 312, name: "Ta-Ha" },
    "21": { page: 322, name: "Al-Anbiya" },
    "22": { page: 332, name: "Al-Hajj" },
    "23": { page: 342, name: "Al-Mu'minun" },
    "24": { page: 350, name: "An-Nur" },
    "25": { page: 359, name: "Al-Furqan" },
    "26": { page: 367, name: "Ash-Shu'ara" },
    "27": { page: 377, name: "An-Naml" },
    "28": { page: 385, name: "Al-Qasas" },
    "29": { page: 396, name: "Al-Ankabut" },
    "30": { page: 404, name: "Ar-Rum" },
    "31": { page: 411, name: "Luqman" },
    "32": { page: 415, name: "As-Sajda" },
    "33": { page: 418, name: "Al-Ahzab" },
    "34": { page: 428, name: "Saba" },
    "35": { page: 434, name: "Fatir" },
    "36": { page: 440, name: "Ya-Sin" },
    "37": { page: 446, name: "As-Saffat" },
    "38": { page: 453, name: "Sad" },
    "39": { page: 458, name: "Az-Zumar" },
    "40": { page: 467, name: "Ghafir" },
    "41": { page: 477, name: "Fussilat" },
    "42": { page: 483, name: "Ash-Shura" },
    "43": { page: 489, name: "Az-Zukhruf" },
    "44": { page: 496, name: "Ad-Dukhan" },
    "45": { page: 499, name: "Al-Jathiya" },
    "46": { page: 502, name: "Al-Ahqaf" },
    "47": { page: 507, name: "Muhammad" },
    "48": { page: 511, name: "Al-Fath" },
    "49": { page: 515, name: "Al-Hujurat" },
    "50": { page: 518, name: "Qaf" },
    "51": { page: 520, name: "Adh-Dhariyat" },
    "52": { page: 523, name: "At-Tur" },
    "53": { page: 526, name: "An-Najm" },
    "54": { page: 529, name: "Al-Qamar" },
    "55": { page: 531, name: "Ar-Rahman" },
    "56": { page: 534, name: "Al-Waqia" },
    "57": { page: 537, name: "Al-Hadid" },
    "58": { page: 542, name: "Al-Mujadila" },
    "59": { page: 545, name: "Al-Hashr" },
    "60": { page: 549, name: "Al-Mumtahina" },
    "61": { page: 551, name: "As-Saff" },
    "62": { page: 553, name: "Al-Jumua" },
    "63": { page: 554, name: "Al-Munafiqoon" },
    "64": { page: 556, name: "At-Taghabun" },
    "65": { page: 558, name: "At-Talaq" },
    "66": { page: 560, name: "At-Tahrim" },
    "67": { page: 562, name: "Al-Mulk" },
    "68": { page: 564, name: "Al-Qalam" },
    "69": { page: 566, name: "Al-Haqqah" },
    "70": { page: 568, name: "Al-Maarij" },
    "71": { page: 570, name: "Nuh" },
    "72": { page: 572, name: "Al-Jinn" },
    "73": { page: 574, name: "Al-Muzzammil" },
    "74": { page: 575, name: "Al-Muddathir" },
    "75": { page: 577, name: "Al-Qiyamah" },
    "76": { page: 578, name: "Al-Insan" },
    "77": { page: 580, name: "Al-Mursalat" },
    "78": { page: 582, name: "An-Naba" },
    "79": { page: 583, name: "An-Nazi'at" },
    "80": { page: 585, name: "Abasa" },
    "81": { page: 586, name: "At-Takwir" },
    "82": { page: 587, name: "Al-Infitar" },
    "83": { page: 588, name: "Al-Mutaffifin" },
    "84": { page: 589, name: "Al-Inshiqaq" },
    "85": { page: 590, name: "Al-Buruj" },
    "86": { page: 591, name: "At-Tariq" },
    "87": { page: 592, name: "Al-Ala" },
    "88": { page: 593, name: "Al-Ghashiya" },
    "89": { page: 594, name: "Al-Fajr" },
    "90": { page: 595, name: "Al-Balad" },
    "91": { page: 596, name: "Ash-Shams" },
    "92": { page: 596, name: "Al-Lail" },
    "93": { page: 597, name: "Ad-Duha" },
    "94": { page: 597, name: "Ash-Sharh" },
    "95": { page: 598, name: "At-Tin" },
    "96": { page: 598, name: "Al-Alaq" },
    "97": { page: 599, name: "Al-Qadr" },
    "98": { page: 599, name: "Al-Bayyina" },
    "99": { page: 600, name: "Az-Zalzala" },
    "100": { page: 600, name: "Al-Adiyat" },
    "101": { page: 601, name: "Al-Qaria" },
    "102": { page: 601, name: "At-Takathur" },
    "103": { page: 601, name: "Al-Asr" },
    "104": { page: 602, name: "Al-Humaza" },
    "105": { page: 602, name: "Al-Fil" },
    "106": { page: 602, name: "Quraish" },
    "107": { page: 602, name: "Al-Ma'un" },
    "108": { page: 603, name: "Al-Kawthar" },
    "109": { page: 603, name: "Al-Kafirun" },
    "110": { page: 603, name: "An-Nasr" },
    "111": { page: 603, name: "Al-Masad" },
    "112": { page: 604, name: "Al-Ikhlas" },
    "113": { page: 604, name: "Al-Falaq" },
    "114": { page: 604, name: "An-Nas" },
  };

  // console.log("=-=-=-=", all_pages[surahNum]);

  return all_pages[surahNum]?.page || 1;
};

export const timeCalculator = (timestamp: number | string | Date): string => {
  const now = new Date();
  const past = new Date(timestamp);
  const seconds = Math.floor((now.getTime() - past.getTime()) / 1000);
  const isArabic = store.getState().global.isArabic;

  let interval = Math.floor(seconds / 31536000); // Years

  if (interval >= 1) {
    return isArabic
      ? `${interval} ${interval > 1 ? "سنوات" : "سنة"} مضت`
      : `${interval} year${interval > 1 ? "s" : ""} ago`;
  }
  interval = Math.floor(seconds / 2592000); // Months
  if (interval >= 1) {
    return isArabic
      ? `${interval} ${interval > 1 ? "أشهر" : "شهر"} مضت`
      : `${interval} month${interval > 1 ? "s" : ""} ago`;
  }
  interval = Math.floor(seconds / 86400); // Days
  if (interval >= 1) {
    return isArabic
      ? `${interval} ${interval > 1 ? "أيام" : "يوم"} مضت`
      : `${interval} day${interval > 1 ? "s" : ""} ago`;
  }
  interval = Math.floor(seconds / 3600); // Hours
  if (interval >= 1) {
    return isArabic
      ? `${interval} ${interval > 1 ? "ساعات" : "ساعة"} مضت`
      : `${interval} hour${interval > 1 ? "s" : ""} ago`;
  }
  interval = Math.floor(seconds / 60); // Minutes
  if (interval >= 1) {
    return isArabic
      ? `${interval} ${interval > 1 ? "دقائق" : "دقيقة"} مضت`
      : `${interval} minute${interval > 1 ? "s" : ""} ago`;
  }
  return isArabic ? "الآن" : "Just now";
};

export const ShowToast = (
  toast: CreateToastFnReturn,
  message: string,
  status: "success" | "error" | "warning"
) => {
  if (status === "success") {
    toast({
      title: message,
      status: status,
      isClosable: true,
      containerStyle: {
        backgroundColor: "green",
        borderRadius: 5,
      },
    });
  } else if (status === "error") {
    toast({
      title: message,
      status: status,
      isClosable: true,
      containerStyle: {
        backgroundColor: "red",
        borderRadius: 5,
      },
    });
  } else {
    toast({
      title: message,
      status: status,
      isClosable: true,
      containerStyle: {
        backgroundColor: "orange",
        borderRadius: 5,
      },
    });
  }
};

// export function createAyahNumber(number: number): string {
//   const arabicNumbers: { [key: number]: string } = {
//     1: "\u0661",
//     2: "\u0662",
//     3: "\u0663",
//     4: "\u0664",
//     5: "\u0665",
//     6: "\u0666",
//     7: "\u0667",
//     8: "\u0668",
//     9: "\u0669",
//     0: "\u0660",
//   };

//   // const circle = '\u25EF';
//   // const circle = '\u06DD';
//   // const circle = '\u25EF'; // hollow circle

//   const numberStr = number.toString();
//   let arabicNumber = "";

//   for (let digit of numberStr) {
//     arabicNumber += arabicNumbers[parseInt(digit)];
//   }

//   // return circle + arabicNumber + circle;
//   // return circle + arabicNumber;

//   return arabicNumber;
// }

export const normalizeArabic = (text: string) =>
  text.replace(/[\u064B-\u065F\u06D6-\u06ED]/g, "");

export function createAyahNumber(input: number): string {
  const englishToArabic: { [key: string]: string } = {
    "0": "٠",
    "1": "١",
    "2": "٢",
    "3": "٣",
    "4": "٤",
    "5": "٥",
    "6": "٦",
    "7": "٧",
    "8": "٨",
    "9": "٩",
  };

  return input
    .toString()
    .split("")
    .map((char) => englishToArabic[char] || char)
    .join("");
}

export const removeBismillah = (it: string) => {
  return it
    .replace("بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ", "")
    .replace("بِّسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ", "");
};
